import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';


export default {
    
  all () {
    return Firebase.firestore().collection('course').orderBy('priority', 'asc')
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  retriveFiles(c){
    return Firebase.firestore().collection('course')
      .doc(c.docId)
      .collection('files')
      .orderBy('uploadedAt')
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },
  retriveQuestions(c){
    return Firebase.firestore().collection('course')
      .doc(c.title)
      .collection('quiz')
      .get()
      .then((docs) => {
        return Firestore.getCollectionData(docs);
      });
  },

  add (chapter) {
    const chapterObj = {
      title : chapter,

      createdAt : new Date()
    };

    return Firebase.firestore().collection('course')
        // .doc(chapter)
      .add(chapterObj);
  },

  manageModule(module) {
    // console.log("module", module)
      const moduleObj = { 
        ...module
      };
      // console.log(moduleObj)
      const promise = moduleObj.docId
        ? Firebase.firestore()
            .collection('course')
            .doc(moduleObj.docId)
            .update(moduleObj)
        : Firebase.firestore()
            .collection('course')
            .add(moduleObj);
      return promise;
    },
  manage(id, c,file) {
    console.log(id)
    console.log("file", file)
      const ChapterObj = { 
        ...file
      };
      console.log(ChapterObj, c.docId, id)
      const promise = id
        ? Firebase.firestore()
            .collection('course')
            .doc(c.docId)
            .collection('files')
            .doc(id)
            .update(ChapterObj)
        : Firebase.firestore()
            .collection('course')
            .doc(c.docId)
            .collection('files')
            .add(ChapterObj);
      return promise;
    },

  manageQuestion(id, chapter , quiz) {
    console.log("file", quiz)
      const ChapterObj = { 
        ...quiz
      };
     
      const promise = id
        ? Firebase.firestore()
            .collection('course')
            .doc(chapter.docId)
            .collection('quiz')
            .doc(id)
            .update(ChapterObj)
        : Firebase.firestore()
            .collection('course')
            .doc(chapter.title)
            .collection('quiz')
            .add(ChapterObj);
      return promise;
    },
  
    deleteFile(fileId, chapter) {
      return Firebase.firestore()
        .collection('course')
        .doc(chapter.docId)
        .collection('files')
        .doc(fileId)
        .delete();
    },
    deleteQuestion(questionId, chapter) {
      return Firebase.firestore()
        .collection('course')
        .doc(chapter.docId)
        .collection('quiz')
        .doc(questionId)
        .delete();
    }
};


// WEBPACK FOOTER //
// ./src/pages/course/service.js